import React, { Suspense, lazy } from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import './index.css';
import './chart.css';
import './step.css';

import Nav from './layouts/nav';
import Footer from './layouts/Footer';
import ApplicationMessage from './components/ApplicationMessage/ApplicationMessage';

const MerchantDashboard = lazy(() => import('./pages/MerchantDashboard/merchantDashboard'));
const ScrollToTop = lazy(() => import('./layouts/ScrollToTop'));
const AcessSettings = lazy(() => import('./pages/AccessSettings/manageAccessSettings'));
const TransactionSettings = lazy(() => import('./pages/TransactionSettings/transaction-settings'));
const Profile = lazy(() => import('./pages/Profile/update-profile'));
const AddMerchantBankAccounts = lazy(() => import('./pages/MerchantBankAccounts/add-bank-accounts'));
const MerchantBankAccounts = lazy(() => import('./pages/MerchantBankAccounts/merchants-bank-list'));
const ManageMerchantKYC = lazy(() => import('./pages/MerchantKYC/manage-merchants-kyc'));
const UpdateIPAddress = lazy(() => import('../jsx/pages/MerchantsIpAddress/addUpdateIP'));
const ManageIPAddress = lazy(() => import('./pages/MerchantsIpAddress/manageIP'));
const UpdateFundRequests = lazy(() => import('../jsx/pages/MerchantFundRequests/addUpdateFundRequests'));
const ManageFundRequests = lazy(() => import('./pages/MerchantFundRequests/manageFundRequests'));
const UpdateFundTransfer = lazy(() => import('./pages/MerchantFundTransfer/addBulkFundTransfer'));
const ManageFundTransfer = lazy(() => import('./pages/MerchantFundTransfer/manageFundTransfer'));
const AddBulkFundTransfer = lazy(() => import('./pages/MerchantBulkPayouts/addBulkFundTransfer'));
const ManageBullFundTransfer = lazy(() => import('./pages/MerchantBulkPayouts/manageMerchantPayouts'));
const ViewTransandApprovals = lazy(() => import('./pages/MerchantBulkPayouts/manageMerchantBulkPayoutsandApproval'));
const MerchantPayouts = lazy(() => import('./pages/MerchantPayouts/manageMerchantPayouts'));
const Transactions = lazy(() => import('./pages/Transactions/manageTransactions'));
const ViewTransactions = lazy(() => import('./pages/Transactions/viewTransactions'));
const ComplaintTransactions = lazy(() => import('./pages/Transactions/complaintTransactions'));
const MerchantPayoutReport = lazy(() => import('./pages/MerchantReports/manageMerchantPayoutReports'));
const MerchantFundReport = lazy(() => import('./pages/MerchantReports/manageMerchantFundReports'));
const ManageMerchantSummary = lazy(() => import('./pages/MerchantReports/manageMerchantSummary'));
const ManageDocumentation = lazy(() => import('./pages/Documentation/manageDocumentation'));


const Markup = () => {
  const allroutes = [
    { url: '', component: <MerchantDashboard /> },
    { url: 'dashboard', component: <MerchantDashboard /> },
    { url: 'profile', component: <Profile /> },
    { url: 'access-key-settings', component: <AcessSettings /> },
    { url: 'transaction-settings', component: <TransactionSettings /> }, 
    { url: 'merchants-bank-accounts/create', component: <AddMerchantBankAccounts /> },
    { url: 'merchants-bank-accounts/update/:id', component: <AddMerchantBankAccounts /> },
    { url: 'merchants-bank-accounts', component: <MerchantBankAccounts /> },
    { url: 'merchants-kyc', component: <ManageMerchantKYC /> },
    { url: 'ip-whitelisted/create', component: <UpdateIPAddress /> },
    { url: 'ip-whitelisted/update/:id', component: <UpdateIPAddress /> },
    { url: 'ip-whitelisted', component: <ManageIPAddress /> },
    { url: 'fund-requests/create', component: <UpdateFundRequests /> },
    { url: 'fund-requests/update/:id', component: <UpdateFundRequests /> },
    { url: 'fund-requests', component: <ManageFundRequests /> },
    { url: 'fund-transfer/single', component: <UpdateFundTransfer /> },
    { url: 'fund-transfer/bulk', component: <UpdateFundTransfer /> },
    { url: 'bulk-fund-transfer/create', component: <AddBulkFundTransfer /> },
    { url: 'bulk-fund-transfer/:id', component: <ViewTransandApprovals /> },
    { url: 'bulk-fund-transfer', component: <ManageBullFundTransfer /> },
    { url: 'fund-transfer', component: <ManageFundTransfer /> },
    { url: 'transactions', component: <Transactions /> },
    { url: 'transactions/complaint/:id', component: <ComplaintTransactions /> },
    { url: 'transactions/view/:id', component: <ViewTransactions /> },
    { url: 'manage-transactions', component: <MerchantPayouts /> },
    { url: 'reports/fund-requests', component: <MerchantFundReport /> },
    { url: 'reports/summary', component: <ManageMerchantSummary /> },
    { url: 'reports/payout', component:  <MerchantPayoutReport />},
    { url: 'documentation', component:  <ManageDocumentation />},
  ];

  return (
    <>
     <Routes>

    
    {/* Main Layout Route */}
    <Route element={<MainLayout />}>
      {allroutes.map((data, i) => (
        <Route
          key={i}
          path={data.url}
          element={
            <Suspense
              fallback={
                <div className="route-loader">
                  <div className="sk-three-bounce">
                    <div className="sk-child sk-bounce1"></div>
                    <div className="sk-child sk-bounce2"></div>
                    <div className="sk-child sk-bounce3"></div>
                  </div>
                </div>
              }
            >
              {data.component}
              <ScrollToTop />
            </Suspense>
          }
        />
      ))}
    </Route>
  </Routes>
    </>
  );
};

function MainLayout() {
  return (
    <div id="main-wrapper" className="show">
      <Nav />
      <div className="content-body" style={{ minHeight: window.screen.height - 45 }}>
        <div className="container-fluid">
          <ApplicationMessage messageType="maintenance" />
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Markup;